// @flow
import React from 'react';
import {
  SpText,
} from '../../../widgetDesign';

type Props = {
  payment: Object,
};

const ThanksInfo = (props: Props) => {
  const {
    payment,
  } = props;

  return (
    <>
      <div style={{ backgroundColor: '#FAFAFC', paddingTop: '30px' }}>
        <SpText
          fontSize="25px"
          color="#5F5F65"
          fontWeight="600"
        >
          Thank You
        </SpText>
        <div className="mt-2">
        <hr style={{
            width: '20%',
            textAlign: 'center',
            height: '6px',
            backgroundColor: `${payment.paymentWidget.primaryColor}`,
            marginLeft: '40%',
          }}
          />
        </div>
      </div>
      <div className="mt-4">
      <SpText
        fontSize="14px"
        style={{lineHeight:"normal"}}
      >
        {payment.paymentWidget.thankYouMessage}
      </SpText>
      </div>
    </>
  );
};

// $FlowFixMe
export default ThanksInfo;
